import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import BillContent from "./BillContent";

const DownloadBillModal = ({ order, isOpen, setIsOpen }) => {
  const { t } = useTranslation();

  const handleGeneratePdf = () => {
    const input = document.getElementById("bill");
    html2canvas(input, { scale: 2, backgroundColor: "#ffffff" }).then(
      (canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({ orientation: "landscape", unit: "px" });
        const pageW = pdf.internal.pageSize.getWidth() - 24;
        const imgH = (canvas.height * pageW) / canvas.width;
        pdf.addImage(imgData, "PNG", 12, 12, pageW, imgH);
        pdf.save(`${order.billNo} - ${order.customer.name}.pdf`);
      },
    );
  };

  return (
    <Modal
      title={t("common.download")}
      centered
      open={isOpen}
      okText={t("common.download")}
      cancelText={t("common.cancle")}
      onOk={handleGeneratePdf}
      onCancel={() => setIsOpen(false)}
      maskClosable={false}
      width={1100}
    >
      {order && <BillContent order={order} billId="bill" />}
    </Modal>
  );
};

export default DownloadBillModal;
